import { useState } from "react";

const CComparePassword = (props) => {
  const labelName1 = props.labelName1;
  const labelName2 = props.labelName2;
  const name1 = props.name1;
  const name2 = props.name2;
  const customStyle = props.customStyle1 === undefined ? {} : props.customStyle;
  const customStyleLabel= props.customStyleLabel === undefined ? {} : props.customStyleLabel;
  const customClassLabel =
    props.customClassLabel === undefined ? "" : props.customClassLabel;
  const customClassInput =
    props.customClassInput === undefined ? "" : props.customClassInput;
  const customClassRowDiv =
    props.customClassRowDiv === undefined ? "" : props.customClassRowDiv;
  const customClassColDiv =
    props.customClassColDiv === undefined ? "" : props.customClassColDiv;
  const required = props.required === true ? true : false;
  const placeholder1 = props.placeholder1 === undefined ? "" : props.placeholder1;
  const placeholder2 = props.placeholder2 === undefined ? "" : props.placeholder2;

  const [errorMsg, setErrorMsg] = useState("");
  const [isValid, setIsValid] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [matchPass, setMatchPass] = useState("");

  const newPass = (newpass) => {
    setNewPassword(newpass);
    if (newpass === matchPass) {
      setIsValid("");
      setErrorMsg("");
      props.functionName(name1, newpass);
    } else {
      setIsValid("is-invalid");
      setErrorMsg("Password doesn't Match");
      props.functionName(name1, "");
    }
  };

  const matchPassword = (confirmPassword) => {
    setMatchPass(confirmPassword);
    if (newPassword === confirmPassword) {
      setIsValid("");
      setErrorMsg("");
      props.functionName(name1, newPassword);
    } else {
      setIsValid("is-invalid");
      setErrorMsg("Password doesn't Match");
      props.functionName(name1, "");
    }
  };

  const checkRequiredNew = (pass) => {
    if (pass.length > 0) {
      setNewPassword(pass);
      if (pass === matchPass) {
        setErrorMsg("");
        setIsValid("");
      } else {
        setIsValid("is-invalid");
        setErrorMsg("Password doesn't Match");
      }
    } else {
      setIsValid("is-invalid");
      setErrorMsg("Please fill this field");
    }
  };

  const checkRequiredConfirm = (Conpass) => {
    if (Conpass.length > 0) {
      setMatchPass(Conpass);
      if (newPassword === Conpass) {
        setErrorMsg("");
        setIsValid("");
        props.functionName(name1, newPassword);
      } else {
        setIsValid("is-invalid");
        setErrorMsg("Password doesn't Match");
      }
    } else {
      setIsValid("is-invalid");
      setErrorMsg("Please fill this field");
    }
  };

  return (
    <>
      <div className={`${customClassRowDiv} row`}>
        <div className={`${customClassColDiv} col-md-6 col-sm-12`}>
          <label className={`form-label ${customClassLabel}`} style={customStyleLabel}>
            {labelName1}
          </label>
          <input
            className={`form-control ${customClassInput}`}
            style={customStyle}
            name1={name1}
            type="password"
            placeholder={placeholder1}
            required={required}
            onChange={(event) =>
              required === true
                ? checkRequiredNew(event.target.value)
                : newPass(event.target.value)
            }
          />
          {/* <div className="invalid-feedback">{errorMsg}</div> */}
        </div>

        <div className={`${customClassColDiv} col-md-6 col-sm-12 mt-sm-5 mt-md-0`}>
          <label className={`form-label ${customClassLabel}`} style={customStyleLabel}>
            {labelName2}
          </label>
          <input
            className={`form-control ${customClassInput} ${isValid}`}
            style={customStyle}
            name2={name2}
            type="password"
            placeholder={placeholder2}
            required={required}
            onChange={(event) => {
              required === true
                ? checkRequiredConfirm(event.target.value)
                : matchPassword(event.target.value);
            }}
          />
          <div className="invalid-feedback">{errorMsg}</div>
        </div>
      </div>
    </>
  );
};

export default CComparePassword;
